import { render, staticRenderFns } from "./FullscreenTextInput.vue?vue&type=template&id=58ed1086&scoped=true&"
import script from "./FullscreenTextInput.vue?vue&type=script&lang=js&"
export * from "./FullscreenTextInput.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenTextInput.vue?vue&type=style&index=0&id=58ed1086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ed1086",
  null
  
)

export default component.exports